module.exports = __webpack_public_path__ + "static/media/Milex-Gellhorn-Pessary-Instructions-for-Use@2x.600e4536.jpg";